
import React, { useEffect, useState } from 'react';
import { PageSection, Product, SiteTheme } from '../../../types';
import { db } from '../../../services/db';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ProductCard } from '../../store/ProductCard';

interface LandingProductGridProps {
    section: PageSection;
    theme?: SiteTheme;
}

export const LandingProductGrid: React.FC<LandingProductGridProps> = ({ section, theme }) => {
    const navigate = useNavigate();
    const [products, setProducts] = useState<Product[]>([]);
    
    useEffect(() => {
        db.getProducts().then(data => {
            setProducts(data.filter(p => !!p.categoryId));
        });
    }, []);

    return (
        <div className="py-24 px-6 bg-background border-t border-accent/20">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4 leading-tight">
                        {section.title || 'Hela vårt sortiment'}
                    </h2>
                    {section.text && (
                        <p className="text-secondary max-w-2xl mx-auto leading-relaxed font-light text-lg">
                            {section.text}
                        </p>
                    )}
                </div>

                {products.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 mb-12">
                        {products.map(product => (
                            <ProductCard 
                                key={product.id} 
                                product={product} 
                                onAddToCart={() => navigate('/store')} 
                                cardStyle={theme?.productCardStyle || 'classic'}
                            />
                        ))}
                    </div>
                )}

                <div className="text-center">
                    <button 
                        onClick={() => navigate('/store')}
                        className="inline-flex items-center gap-2 px-10 py-4 bg-primary text-white rounded-full font-bold text-xs uppercase tracking-widest hover:bg-secondary transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300"
                    >
                        Gå till Butiken <ArrowRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};
